import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';
import { configurationApi } from '@services/configuration';

export type BusinessRegistrationState = {
  countryToBusinessRegistrationEnabled: Record<string, boolean>;
};

const initialState: BusinessRegistrationState = {
  countryToBusinessRegistrationEnabled: {},
};

export const BUSINESS_REGISTRATION_SLICE_NAME = 'businessRegistration';

export const businessRegistrationSlice = createSlice({
  name: BUSINESS_REGISTRATION_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addMatcher(
      configurationApi.endpoints.getConfiguration.matchFulfilled,
      (state, { payload }) => {
        state.countryToBusinessRegistrationEnabled = {
          ...payload.countryToBusinessRegistrationEnabled,
        };
      },
    );
  },
});
export const selectCountryToBusinessRegistrationEnabled = (state: RootState) =>
  state.businessRegistration.countryToBusinessRegistrationEnabled;

export default businessRegistrationSlice.reducer;
